import { Directive, ElementRef, Output, EventEmitter, Inject, forwardRef } from '@angular/core';
//import { State, Options } from'./ng2-animate-scroll.interface';
var AnimateBoxDirective = /** @class */ (function () {
    function AnimateBoxDirective(element) {
        this.element = element;
        //@Input('animatebox') options: Options;
        this.output = new EventEmitter();
        this.classNameSetByAnimateBox = '';
    }
    AnimateBoxDirective.prototype.ngAfterViewInit = function () {
        setTimeout(function () {
            //this._processEvent();
        }, 0);
    };
    AnimateBoxDirective.prototype._processEvent = function () {
        /*
        if (!this.options || typeof (this.options) === 'string' || typeof (this.options) === 'number') {
            //no options or incorrect options provided -> proceed with default states
            console.warn('animatebox:', 'Invalid options provided:', this.options);
        }
        else {
            if (typeof (this.options.states) === 'undefined' || !this.options.states.length) {
                //this._applyDefaultStates();
            }
            else {
                
                let stateApplied: boolean = false;
                for (let i = 0; !stateApplied && i < this.options.states.length; i++) {
                    if (this._processState(this.options.states[i])) {
                        stateApplied = true;
                    };
                }
                if (!stateApplied) {
                    //no state matched -> proceed with default states
                    this._applyDefaultStates();
                }
                
            }
        }
        */
    };
    AnimateBoxDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[animatebox]'
                },] },
    ];
    /** @nocollapse */
    AnimateBoxDirective.ctorParameters = function () { return [
        { type: ElementRef, decorators: [{ type: Inject, args: [forwardRef(function () { return ElementRef; }),] },] },
    ]; };
    AnimateBoxDirective.propDecorators = {
        'output': [{ type: Output, args: ['animatebox',] },],
    };
    return AnimateBoxDirective;
}());
export { AnimateBoxDirective };
//# sourceMappingURL=ng2-animate-box.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-animate-scroll/dist/src/ng2-animate-box.directive.js
// module id = ./node_modules/ng2-animate-scroll/dist/src/ng2-animate-box.directive.js
// module chunks = vendor